export default "__VITE_ASSET__D14aRoof__"